import angular from 'angular';

import {
  eAdditionalFieldTypesConstant,
  eAdminFeaturesConstant,
  eCodeOptionsTypeConstant,
  eDocumentStatusConstant,
  eFeaturesConstant,
  eLogTypeConstant,
  eQuickAccessItemsConstant,
  eTaskTypesConstant,
  eTreeItemTypesConstant,
  extIconsConstant,
  imgTypesConstant,
  officeTypesConstant,
  officeCompatiblesConstant,
  runtimeConstant,
  textTypesConstant,
  tiffTypesConstant,
  videoTypesConstant,
  webApiSettingsConstant,
} from '../constants';

const module = 'app.constants';
const requires = [];

angular.module(module, requires);
angular.module(module).registerComponents(
  {
    eAdditionalFieldTypesConstant,
    eAdminFeaturesConstant,
    eCodeOptionsTypeConstant,
    eDocumentStatusConstant,
    eFeaturesConstant,
    eLogTypeConstant,
    eQuickAccessItemsConstant,
    eTaskTypesConstant,
    eTreeItemTypesConstant,
    extIconsConstant,
    imgTypesConstant,
    officeTypesConstant,
    officeCompatiblesConstant,
    runtimeConstant,
    textTypesConstant,
    tiffTypesConstant,
    videoTypesConstant,
    webApiSettingsConstant,
  },
  'constant'
);
